export default {
    tutorialShouldWelcome: 'tutorial.should.welcome',
    tutorialAutoTutorial: 'tutorial.auto.tutorial',
};
